// extracted by mini-css-extract-plugin
export default {"upDown":"UpDown_upDown__mfLsZ","enabled":"UpDown_enabled__xcI6g","size":"UpDown_size__V2YSl"};